import {
  GET_HOLIDAY,
  GET_HOLIDAY_FAIL,
  GET_HOLIDAY_SUCCESS,
  GET_HOLIDAY_DETAILS,
  GET_HOLIDAY_DETAILS_FAIL,
  GET_HOLIDAY_DETAILS_SUCCESS,
  ADD_NEW_HOLIDAY,
  ADD_HOLIDAY_SUCCESS,
  ADD_HOLIDAY_FAIL,
  UPDATE_HOLIDAY,
  UPDATE_HOLIDAY_SUCCESS,
  UPDATE_HOLIDAY_FAIL,
  DELETE_HOLIDAY,
  DELETE_HOLIDAY_SUCCESS,
  DELETE_HOLIDAY_FAIL,  
  RESET_HOLIDAY_STATE,
} from "./actionTypes";

export const getHoliday = ({length, sort, page,name, sort_by}) => ({
  type: GET_HOLIDAY,
  payload: {length, sort, page,name, sort_by},
});

export const getHolidaySuccess = holiday => ({
  type: GET_HOLIDAY_SUCCESS,
  payload: holiday,
});

export const getHolidayFail = error => ({
  type: GET_HOLIDAY_FAIL,
  payload: error,
});

export const getHolidayDetails = ({id}) => ({
  type: GET_HOLIDAY_DETAILS,
  payload: {id},
});

export const getHolidayDetailsSuccess = holiday => ({
  type: GET_HOLIDAY_DETAILS_SUCCESS,
  payload: holiday,
});

export const getHolidayDetailsFail = error => ({
  type: GET_HOLIDAY_DETAILS_FAIL,
  payload: error,
});

//add 
export const addNewHoliday = holiday => ({
  type: ADD_NEW_HOLIDAY,
  payload: holiday,
});

export const addHolidaySuccess = holiday => ({
  type: ADD_HOLIDAY_SUCCESS,
  payload: holiday,
});

export const addHolidayFail = error => ({
  type: ADD_HOLIDAY_FAIL,
  payload: error,
});

//update 
export const updateHoliday =({id, holiday}) => ({
  type: UPDATE_HOLIDAY,
  payload:{id, holiday},
});

export const updateHolidaySuccess = holiday => ({
  type: UPDATE_HOLIDAY_SUCCESS,
  payload: holiday,
});

export const updateHolidayFail = error => ({
  type: UPDATE_HOLIDAY_FAIL,
  payload: error,
});

//delete 
export const deleteHoliday =({id}) => ({
  type: DELETE_HOLIDAY,
  payload:{id},
});

export const deleteHolidaySuccess = holiday => ({
  type: DELETE_HOLIDAY_SUCCESS,
  payload: holiday,
});

export const deleteHolidayFail = error => ({
  type: DELETE_HOLIDAY_FAIL,
  payload: error,
});

//reset
export const resetHolidayState = () => {
  return {
      type: RESET_HOLIDAY_STATE,
  }
}


